import Router from 'next/router';
import { Amplify } from 'aws-amplify';
let localStorageKey = 'reckon:access-token';

export function configureAmplifyAuth(clientId: string) {
  const authConfig = {
    Auth: {
      Cognito: {
        identityPoolId: process.env.identityPoolId!,
        region: process.env.region!,
        userPoolId: process.env.userPoolId!,
        userPoolClientId: clientId,
        authenticationFlowType: 'USER_SRP_AUTH',
        loginWith: {
          oauth: {
            domain: process.env.oauthDomain!,
            scopes: process.env.oauthScope?.split(',') || [
              'openid',
              'email',
              'profile',
            ],
            redirectSignIn: [process.env.oauthRedirectSignIn!],
            redirectSignOut: [process.env.oauthRedirectSignOut!],
            responseType:
              (process.env.oauthResponseType as 'code' | 'token') || 'code',
          },
        },
      },
    },
  };
  Amplify.configure(authConfig);
}

export function configureAPSAuth() {
  const apsCognitoConfig =
    (process.env.apsCognito as unknown as {
      [key: string]: string;
    }) || {};
  const authConfig = {
    Auth: {
      Cognito: {
        identityPoolId: apsCognitoConfig.identityPoolId,
        region: process.env.region!,
        userPoolId: apsCognitoConfig.userPoolId,
        userPoolClientId: apsCognitoConfig.clientId,
        loginWith: {
          oauth: {
            domain: apsCognitoConfig.oauthDomain,
            scopes: process.env.oauthScope?.split(',') || [
              'openid',
              'email',
              'profile',
            ],
            redirectSignIn: [process.env.oauthRedirectSignIn!],
            redirectSignOut: [process.env.oauthRedirectSignOut!],
            responseType:
              (process.env.oauthResponseType as 'code' | 'token') || 'code',
          },
        },
      },
    },
  };
  Amplify.configure(authConfig);
}

export function getCredentials(): {
  token?: string;
  refreshToken?: string;
  mfaToken?: string;
} {
  try {
    return typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem(localStorageKey)!) || {}
      : {};
  } catch (err: any) {
    return {};
  }
}

export function setCredentials(creds: {
  token?: string;
  refreshToken?: string;
  mfaToken?: string;
}) {
  if (typeof window !== 'undefined')
    localStorage.setItem(localStorageKey, JSON.stringify(creds));
}

export function clearCredentials() {
  if (typeof window !== 'undefined') localStorage.removeItem(localStorageKey);
}

export const logout = () => {
  clearCredentials();
  Router.push('/login');
};
